import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Wrapper,
  Content,
  Logo,
  NavLinks,
  NavLink,
  ContactButton,
  MenuButton,
  MobileNav,
  MobileNavLink,
  MobileContactButton,
} from "./Header.styles";
import logo from "../../images/Logo.webp";

const navItems = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About Us" },
  { href: "/#businesses", label: "Our Divisions" },
  { href: "/tyres", label: "Premium Tyres" },
  { href: "/minggo", label: "Kids Toys Store" },
  { href: "/minggo-playzone", label: "Kids Playzone" },
  { href: "/#contact", label: "Contact Us" },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen((open) => !open);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  return (
    <Wrapper>
      <Content>
        <Logo as={Link} to="/" onClick={closeMenu}>
          <img src={logo} alt="Jindal Group Logo" />
        </Logo>
        <NavLinks>
          {navItems.slice(0, 6).map((item) => (
            <NavLink as={Link} key={item.label} to={item.href} onClick={closeMenu}>
              {item.label}
            </NavLink>
          ))}
        </NavLinks>
        <ContactButton as={Link} to="/#contact">Contact Us</ContactButton>
        <MenuButton
          type="button"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          onClick={toggleMenu}
          $open={menuOpen}
        >
          <span />
          <span />
          <span />
        </MenuButton>
      </Content>

      <MobileNav $open={menuOpen} aria-hidden={!menuOpen}>
        {navItems.slice(0, 6).map((item) => (
          <MobileNavLink as={Link} key={item.label} to={item.href} onClick={closeMenu}>
            {item.label}
          </MobileNavLink>
        ))}
        <MobileContactButton as={Link} to="/#contact" onClick={closeMenu}>
          Contact Us
        </MobileContactButton>
      </MobileNav>
    </Wrapper>
  );
};

export default Header;
